// Roof-pitch math, mirroring app/integrations/google/solar.py on the backend so the numbers shown
// in the UI agree exactly with the ones the Solar API analysis reports.
//
// TERMINOLOGY (standard US roofing):
//   pitch  — rise in inches per 12" of horizontal run, written "8/12".
//   pitch multiplier ("pitch factor") — sqrt(rise² + 12²) / 12. Converts a FLAT (plan/footprint)
//            area into actual sloped roof surface area.
//
// WHY THE MULTIPLIER MATTERS HERE: tracing a polygon on a top-down satellite image measures the
// building's FOOTPRINT, not its roof surface. A 6,000 sqft footprint at 8/12 is really ~7,200 sqft
// of shingles. Every traced area is therefore reported both ways — raw footprint and
// pitch-corrected — so a trace can be compared against a professional aerial report.

/** Factor converting FLAT (plan/footprint) area into actual sloped roof area.
 *  4/12 → 1.054, 6/12 → 1.118, 8/12 → 1.202, 12/12 → 1.414. */
export function pitchMultiplier(risePer12: number): number {
  return Math.sqrt(risePer12 * risePer12 + 144) / 12;
}

/** "8/12" for a whole rise, "8.2/12" when the measured rise isn't a round number. */
export function formatPitch(risePer12: number): string {
  const rounded = Math.round(risePer12);
  return Math.abs(risePer12 - rounded) < 0.05 ? `${rounded}/12` : `${risePer12.toFixed(1)}/12`;
}
